import { parseInt } from 'lodash'
import { Currency, Locale } from '../types/locale'
import { TO_CENTS } from './checkout'

export function formatPriceInFractionalCurrency(
  fractionalPrice: number,
  currency: Currency,
  locale: Locale,
  minimumFractionDigits = 2,
) {
  const price = convertFractionalToWholeCurrency(fractionalPrice)
  return formatPriceInWholeCurrency(
    price,
    currency,
    locale,
    minimumFractionDigits,
  )
}

export function formatPriceInWholeCurrency(
  price: number,
  currency: Currency,
  locale: Locale,
  minimumFractionDigits = 2,
) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: minimumFractionDigits,
  }).format(price)
}

export function convertFractionalToWholeCurrency(wholePrice: number) {
  return wholePrice / TO_CENTS
}

export function convertWholeToFractionalCurrency(fractionalPrice: number) {
  return parseInt((fractionalPrice * TO_CENTS).toFixed())
}

export function trimFormattedUSPhone(input: string): string {
  let trimmed = input.trim()
  // First remove leading country code.
  trimmed = trimmed.replace(/^(\+?1)/, '')
  // Then any non-digit characters.
  trimmed = trimmed.replace(/\D/g, '')
  return trimmed
}

export function normalizeSpaces(input: string): string {
  return input.replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ')
}
